import React, { useMemo, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '@eas/common-web';
import Link from '@material-ui/core/Link';
import { Menubar } from '../../components/menubar/menubar';
import { MenubarItem } from '../../components/menubar/menubar-types';
import { useIntl } from 'react-intl';
import { Langbar } from '../langbar/langbar';
import { useStyles } from './requster-menu-styles';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Divider from '@material-ui/core/Divider';

function RequesterMenuActions() {
  const { user, logout } = useContext(UserContext);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Langbar />

      <Divider orientation="vertical" flexItem className={classes.divider} />

      <Hidden xsDown>
        <Link href="/requester/profile">
          <p className={classes.name}>{user.name}</p>
        </Link>
      </Hidden>

      <Hidden smUp>
        <IconButton href="/requester/profile" className={classes.icon}>
          <AccountCircleIcon />
        </IconButton>
      </Hidden>

      <IconButton className={classes.icon} onClick={() => logout()}>
        <ExitToAppIcon />
      </IconButton>
    </div>
  );
}

export function RequesterMenu() {
  const history = useHistory();
  const intl = useIntl();

  const publicMenuItems: MenubarItem[] = useMemo(
    () => [
      {
        label: intl.formatMessage({
          id: 'KS_P_MENU_TICKETS',
          defaultMessage: 'Moje Dotazy',
        }),
        onClick: () => history.push('/requester/tickets'),
      },
      {
        label: intl.formatMessage({
          id: 'KS_P_MENU_FAQ',
          defaultMessage: 'Časté dotazy',
        }),
        onClick: () => history.push('/faq'),
      },
    ],
    [history, intl]
  );

  return (
    <Menubar items={publicMenuItems} ActionComponent={RequesterMenuActions} />
  );
}
